import e from "react";
const o = e.createContext({
  theme: "light",
  toggleTheme: () => {
  }
});
export {
  o as ThemeContext,
  o as default
};
